import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { Menu } from 'antd';

import {
  HOME_PAGE,
  LISTING_POSTS_PAGE,
  ADMIN_PARTENAIRE_PAGE,
  SUPER_ADMIN_LIST_DOSSIER,
  CONTACT_PAGE,
  LOGIN_PAGE,
  LIST_RESERVATION,
  CONDITION_PAGE,
  BLOG_PAGE,
  LIST_LOCATION,
  ADMIN_LOCATION,
  LISTING_POSTS_PAGE_CAR,
  LISTING_POSTS_PAGE_AIRBNB,
  ADMIN_AIRBNB_GESTION_LOGEMENT,
  ADMIN_PARTENAIRE_AIRBNB_GESTION_PARTENAIRE
} from 'settings/constant';
import { AuthContext } from 'context/AuthProvider';
import { SharedDataContext } from 'context/SharedDataProvider';




const FooterMenu = () => {
  const {  searchType } = useContext(SharedDataContext);
  const {user} = useContext(AuthContext);

  let navigations = [
    {
      label: <NavLink to={HOME_PAGE}>Accueil</NavLink>,
      key: 'hotels',
    },
    {
      label:<NavLink to={LISTING_POSTS_PAGE}>Hôtels</NavLink>,
      key: "menu-2",
    },
    {
      label: <NavLink to={LISTING_POSTS_PAGE_AIRBNB}>Loc. saisonnière</NavLink>,
      key: "menu-3",
    },
    {
      label: <NavLink to={LISTING_POSTS_PAGE_CAR}>Voitures</NavLink>,
      key: 'listing',
    }
  ];
  
  const addLienIfNotExist = (lien,key) => {
    let existe = 0;
    navigations.forEach(element => {
        if(element.key === key){
          existe = 1;
        }
    });
    if(existe === 0) {
      navigations.push(lien);
    }
  }
  
  const supprimerLien = (key)=>{
  let tmpMenu = [];
  navigations.forEach( (element ,i) => {
    if(element.key !== key){
      tmpMenu.push(element);
    }
  });
  navigations = tmpMenu;
  }
  
  
  let lienSuperAdmin =  {
    label: <NavLink to={SUPER_ADMIN_LIST_DOSSIER}>Admin</NavLink>,
    key: 'super-admin',
  };

  let toPartenaire;
  if ((user?.roles?.includes('ROLE_ADMIN_HOTEL') || user?.roles?.includes('ROLE_RECEP')) && user?.typePartenariat === 'LOCATION') {
    toPartenaire = ADMIN_LOCATION;
  } else if ((user?.roles?.includes('ROLE_ADMIN_HOTEL') || user?.roles?.includes('ROLE_RECEP')) && user?.typePartenariat === 'AIRBNB') {
    toPartenaire = ADMIN_PARTENAIRE_AIRBNB_GESTION_PARTENAIRE;
  } else {
    toPartenaire = ADMIN_PARTENAIRE_PAGE;
  }

  let lienAdmPartenaire =  {
    label: <NavLink to={toPartenaire}>Partenaire</NavLink>,
    key: 'admin-partenaire',
  };
  
  let withReservation = [
    {
      label: <NavLink to={LIST_RESERVATION}>Réservation</NavLink>,
      key: 'reservation',
    },
    {
      label: <NavLink to={CONTACT_PAGE}>Contact</NavLink>,
      key: 'agent',
    }
  ];

  let withoutReservation = [
    {
      label: <NavLink to={CONTACT_PAGE}>Contact</NavLink>,
      key: 'agent',
    }
  ]

  let nosBlogs = {
    label: <NavLink to={BLOG_PAGE}>Nos blogs</NavLink>,
    key: 'menu-4',
  }

 
  let rgpdNavigation =
    {
      label: <NavLink target='_blank' to={CONDITION_PAGE}>Conditions générales</NavLink>,
      key: 'rgpd',
    }

  if (user?.roles && user.roles.includes('ROLE_CLIENT')){
    navigations = navigations.concat(withReservation.filter(i => !navigations.some(j => i.key === j.key)));
  }
  else 
    navigations = navigations.concat(withoutReservation.filter(i => !navigations.some(j => i.key === j.key)));
    
  navigations.push(nosBlogs);
  
 
  if(user?.roles) {
    supprimerLien('connexion-user');
    if(user.roles.includes('ROLE_SUPER_ADMIN')  
    || user?.roles?.includes('ROLE_AGENT_COM')
    || user?.roles?.includes('ROLE_MANAGER')){
      addLienIfNotExist(lienSuperAdmin,'super-admin');
    }
    else if(user.roles.includes('ROLE_ADMIN_HOTEL')
    || user?.roles?.includes('ROLE_RECEP')){
      addLienIfNotExist(lienAdmPartenaire,'admin-partenaire');
    }
  }

  navigations.push(rgpdNavigation);
  return <Menu items={navigations} />;
};

export default FooterMenu;